import { Component, OnInit } from "@angular/core";
import { UsersApi, ApiNewsletterOptins } from "@tytapp/api";
import { EmailValidator } from "@tytapp/common";

@Component({
    selector: "tyt-newsletter-module",
    templateUrl: "./newsletter-module.component.html",
    styleUrls: ["./newsletter-module.component.scss"]
})
export class NewsletterComponent implements OnInit {

    submitting: boolean = false;
    submitted: boolean = false;
    public email: string;
    public errorText: string;

    hovering: boolean = false;

    newsletterTypes: ApiNewsletterOptins = {};

    newsletterEmails = {
        'shop': 'orders@tyt.com',
        'newsletter': 'tytnetwork@tytnetwork.com'
    }

    selectedNewsletter: string[] = [];

    constructor(
        private usersApi: UsersApi
    ) { }

    ngOnInit() {
    }

    selectNewsletter(newsletter: string) {
        if (this.newsletterTypes[newsletter]) {
            delete this.newsletterTypes[newsletter];
            this.selectedNewsletter.splice(this.selectedNewsletter.indexOf(newsletter), 1);
        } else {
            this.newsletterTypes[newsletter] = true;
            this.selectedNewsletter.push(newsletter);
        }
    }

    async signUp() {
        if (this.submitting) {
            return;
        }
        if (Object.keys(this.newsletterTypes).length === 0) {
            this.errorText = 'Please select a newsletter';
            return;
        }

        let emailValidator = new EmailValidator(this.email);
        let emailIsValid = emailValidator.validate();
        if (emailIsValid !== true) {
            this.errorText = 'Please enter an email';
            return;
        }

        this.submitting = true;
        try {
            let response = await this.usersApi.signupNewsletter({
                email: this.email,
                newsletter_types: <any>this.newsletterTypes
            }).toPromise();
            this.submitted = true;
            this.newsletterTypes = {};
        } catch (e) {
            console.error('Error: ', e);
        }
        this.submitting = false;

    }



}
